import queryString from "query-string"
import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import api from '../../../../../utils/api'
import { AppDepositAttribution } from '../../../../../utils/types'
import { hideGlobalLoader } from '../../../../GlobalLoader'
import Image from "../../../../Presentational/Image"
import CheckoutFlow from './CheckoutFlow'
import styles from "./style.module.scss"




const CheckoutFramesPage: FC = () => {
    const location = useLocation()
    const [processorID, setProcessorID] = useState<number | null>(null)
    const [accountID, setAccountID] = useState<number | null>(null)
    const [amount, setAmount] = useState<string | null>(null)
    const [currencyID, setCurrencyID] = useState<number | null>(null)
    const [appDeposit, setAppDeposit] = useState<AppDepositAttribution | undefined>(undefined)
    const query = queryString.parse(location.search)

    useEffect(() => {
        hideGlobalLoader()
    }, [])

    useEffect(() => {
        const session = typeof query.session === 'string' ? query.session : null
        const token = typeof query.token === 'string' ? query.token : null
        const processorID = typeof query.processorID === 'string' ? +query.processorID : null
        const accountID = typeof query.accountID === 'string' ? +query.accountID : null
        // Treat a non-numeric amount as absent so the page renders null rather than
        // forwarding a raw query string to the BE. The other ids use +query (NaN ->
        // falsy -> null) for the same guard; amount stays a string, so validate it
        // explicitly (THPRT-6277 review M-2).
        const rawAmount = typeof query.amount === 'string' ? query.amount : null
        const amount = rawAmount && /^\d+(\.\d{1,2})?$/.test(rawAmount) ? rawAmount : null
        const currencyID = typeof query.currencyID === 'string' ? +query.currencyID : null
        // THPRT-6558 / AFS-2.1: the ThinkTrader app appends its attribution to the
        // /checkoutcom URL; forward it to initiatePayment so the deposit records as an
        // app deposit. Absent in a normal browser, so behaviour is unchanged (AFS-2.2).
        const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined)
        const attRaw = str(query.att)
        const appDeposit: AppDepositAttribution = {
            sourcePortal: str(query.sourcePortal),
            appsflyerId: str(query.appsflyerId),
            osVersion: str(query.osVersion),
            appVersion: str(query.appVersion),
            att: attRaw !== undefined && /^\d+$/.test(attRaw) ? +attRaw : undefined,
            advertisingId: str(query.advertisingId),
        }
        setTimeout(() => {
            if (session && token) {
                api.setTFBOAuth(session, token)
                setProcessorID(processorID)
                setAccountID(accountID)
                setAmount(amount)
                setCurrencyID(currencyID)
                setAppDeposit(appDeposit)
            }
        }, 500)
    }, [query.session, query.token, query.processorID, query.amount, query.currencyID, query.accountID,
        query.sourcePortal, query.appsflyerId, query.osVersion, query.appVersion, query.att, query.advertisingId])

    return (processorID && amount && currencyID && accountID) ? (
        <div className={styles.checkoutpage}>
            <Image className={styles.thinklogo} name='tmLogo' />
            <div className={styles.frames}>
                {/* THPRT-6277: hosts the Checkout.com Flow drop-in for the external
                    deep-link (WebTrader / mobile embed). The caller must pass a Flow
                    sub-processor id; completion is signalled to the host by the
                    /dashboard/funds/status page (postMessageToWTR). */}
                <CheckoutFlow
                    account={{
                        account: {
                            id: accountID
                        }
                    }}
                    processor={{
                        id: processorID,
                        name: 'CheckoutFlow'
                    }}
                    amount={amount}
                    currency={{
                        code: '',
                        id: currencyID,
                    }}
                    isAmountFormValid
                    appDeposit={appDeposit}
                />
            </div>
        </div>
    ) : null
}


export default CheckoutFramesPage